import { InjectionToken } from '@angular/core';

import { getWebSocketUrl } from './get-web-socket-url';
import { environment } from '../../environments/environment';
import { AppState } from '../models/communication/app-state.model';
import { DealerService } from '../services/dealer.service';
import { DemoService } from '../services/demo.service';
import { WsClientService } from '../services/ws-client.service';

export const DealerFactoryToken = new InjectionToken<DealerService>('DEALER_SERVICE');

export const initializeDealerService = (wsClientService: WsClientService<AppState>): DealerService => {
    const wsUrl = getWebSocketUrl(window.location.search, environment.ws.url);

    if (!wsUrl) {
        return new DemoService(wsClientService);
    }

    const dealerService = new DealerService(wsClientService);
    dealerService.setWsUrl(wsUrl);
    return dealerService;
};
